module.exports = __webpack_public_path__ + "static/assets/81503641d782aa3a3f88df14b58bc3e6.png";